import ombraStudioImage from '../img/projects/project-Ombra-Studio.png';
import ombraStudioLogo from '../img/projects/logo-Ombra-Studio.png'
import ateliersBonyImage from '../img/projects/project-Ateliers-Bony.png';
import ateliersBonyLogo from '../img/projects/logo-Ateliers-Bony.png'
import bloomAuraImage from '../img/projects/project-Bloom-Aura.png';
import bloomAuraLogo from '../img/projects/logo-Bloom-Aura.png';
import beaulieuImage from '../img/projects/project-Beaulieu.png';
import beaulieuLogo from '../img/projects/logo-Beaulieu.png';
import comConseilImage from '../img/projects/project-Com-Conseil.png';
import comConseilLogo from '../img/projects/logo-Com-Conseil.png';
import systemikImage from '../img/projects/project-Systemik.png';
import systemikLogo from '../img/projects/logo-Systemik.png';
import opusImage from '../img/projects/project-Opus.png';
import opusLogo from '../img/projects/logo-Opus.png';


export const projectsData = [
    {
        title: 'Ombra Studio',
        description: {
            fr: {
                short: 'Décoration & Ameublement',
                long: `Conception et création d'un site internet pour l'Ombra Studio. Présentation du studio, son histoire, ses travaux et ses coordonnées.`,
            },
            en: {
                short: 'Decoration & Furnishings',
                long: `Design and creation of a website for Ombra Studio. Presentation of the studio, its history, its work and contact details.`,
            },
        },
        imageUrl: ombraStudioImage,
        logoUrl: ombraStudioLogo,
        link: 'https://antoinewtz.github.io/ombra-studio/',
    },
    {
        title: 'Ateliers Bony',
        description: {
            fr: {
                short: 'Menuiserie / Ébénisterie',
                long: `Conception et création d'un site internet pour les Ateliers Bony. Présentation de l'entreprise, de ses services et ses réalisations.`,
            },
            en: {
                short: 'Joinery / Cabinetmaking',
                long: `Design and creation of a website for Ateliers Bony. Presentation of the company, its services and achievements.`,
            },
        },
        imageUrl: ateliersBonyImage,
        logoUrl: ateliersBonyLogo,
        link: 'https://antoinewtz.github.io/ateliers-bony/',
    },
    {
        title: 'Bloom Aura',
        description: {
            fr: {
                short: 'Boutique en ligne',
                long: `Conception et création d'une boutique en ligne pour la marque Bloom Aura. Gestion des produits, compte client, panier d'achat, livraison et paiement.`,
            },
            en: {
                short: 'Online Store',
                long: `Design and creation of an online store for the Bloom Aura brand. Product management, customer account, shopping cart, delivery, and payment.`,
            },
        },
        imageUrl: bloomAuraImage,
        logoUrl: bloomAuraLogo,
        link: '',
    },
    {
        title: 'Gîte du Beaulieu',
        description: {
            fr: {
                short: 'Réservation de séjour',
                long: `Conception et création d'un site internet pour le Gîte du Beaulieu. Présentation du logement, système de réservation et panel administrateur complet.`,
            },
            en: {
                short: 'Stay Reservation',
                long: `Design and creation of a website for the Gîte du Beaulieu. Presentation of the accommodation, reservation system, and complete admin panel.`,
            },
        },
        imageUrl: beaulieuImage,
        logoUrl: beaulieuLogo,
        link: 'https://www.gitedubeaulieu.fr/',
    },
    {
        title: `Com'Conseil`,
        description: {
            fr: {
                short: 'Cabînet expert-comptable',
                long: `Site de démonstration pour le cabinet comptable Com'Conseil. Présentation de l'entreprise et ses valeurs, outils de simulation financier, échéancier et formulaire.`,
            },
            en: {
                short: 'Accountancy firm',
                long: `Demonstration site for the Com'Conseil accounting firm. Presentation of the company and its values, financial simulation tools, schedule and form.`,
            },
        },
        imageUrl: comConseilImage,
        logoUrl: comConseilLogo,
        link: 'https://antoinewtz.github.io/com-conseil/',
    },
    {
        title: `Systemik RH`,
        description: {
            fr: {
                short: 'Cabînet RH',
                long: `Réservation et paiement de formation dédiés aux recruteurs et aux entreprises.`,
            },
            en: {
                short: 'Human Resources firm',
                long: `Training booking and payment dedicated to recruiters and companies.`,
            },
        },
        imageUrl: systemikImage,
        logoUrl: systemikLogo,
        link: 'https://systemik-rh.fr/',
    },
    {
        title: `Opus Musiques`,
        description: {
            fr: {
                short: 'Webzine musical',
                long: `Conception et création d'un blog pour l'association Opus Musiques. Gestion d'articles, de photos et d'événements.`,
            },
            en: {
                short: 'Music webzine',
                long: `Design and creation of a blog for the Opus Musiques association. Management of articles, photos and events.`,
            },
        },
        imageUrl: opusImage,
        logoUrl: opusLogo,
        link: 'https://www.opus-musiques.fr/',
    },
];